// Implements: F-MCK-011
/**
 * Mockup v3 P8: the size of each gallery tab (`GET /mockups/counts`, C2) under
 * `["mockups","counts", scope]`.
 *
 * The counts follow the Ámbito only (P8-3), so the key holds the scope and nothing else: switching
 * tab, searching, filtering by tag or changing the order costs no request, and each scope is asked
 * once. A failed read simply leaves the tabs without numbers (the container shows no error for it).
 * The writes that move a mockup between tabs (favourite, trash, restore, delete, scope) invalidate
 * this key next to the list's (`useMockupActions`).
 */

import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import { GALLERY_COUNTS_KEY } from "../../../shared/api/queryKeys";
import type { GalleryCountsView } from "../../../types/api";
import { NO_FILTERS } from "../api/galleryFilters";
import type { GalleryFilters } from "../api/galleryFilters";
import { fetchGalleryCounts } from "../api/mockupsApi";

type Scope = GalleryFilters["scope"];

export function useGalleryCounts(scope: Scope): UseQueryResult<GalleryCountsView, ApiError> {
  return useQuery<GalleryCountsView, ApiError, GalleryCountsView, readonly [...typeof GALLERY_COUNTS_KEY, Scope]>({
    queryKey: [...GALLERY_COUNTS_KEY, scope],
    queryFn: () => fetchGalleryCounts({ ...NO_FILTERS, scope }),
  });
}
